import { createClient } from '@supabase/supabase-js';
import type { Database } from '@agrogruda/db/types';
import { env } from './env';

export const supabase = createClient<Database>(env.supabaseUrl, env.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storageKey: 'agrogruda-erp-auth',
  },
});

export type SupabaseClient = typeof supabase;
export type TableName = keyof Database['public']['Tables'];
export type Row<T extends TableName> = Database['public']['Tables'][T]['Row'];
export type InsertRow<T extends TableName> = Database['public']['Tables'][T]['Insert'];

export type Profile = Row<'profiles'>;
export type Employee = Row<'employees'>;
export type Activity = Row<'activities'>;
